import InspectionPointPanelPage from './InspectionPointPanelPage';

export default InspectionPointPanelPage;
